module.exports = __webpack_public_path__ + "img/passcard.43807a36.png";